import _ from 'lodash';
import OPU from '@wix/wixrest-utils/dist/Properties';

export function isUsingCashier(organization = {}) {
  return Boolean(OPU.get(organization, 'wixrestaurants.useCashier'));
}

export function transformCreditCardData(cardPublicData) {
  const creditCard = {};

  creditCard.lastDigits = cardPublicData.lastFourDigits;
  creditCard.expiration = cardPublicData.expiration;
  creditCard.network = cardPublicData.type;
  creditCard.additionalFields = cardPublicData.additionalInformation;

  return creditCard;
}

export const SUPPORTED_PAYMENT_METHODS = ['creditCard', 'offline', 'fakePaymentMethod'];

export function filterSupportedPaymentMethods(methods) {
  return methods.filter(m => SUPPORTED_PAYMENT_METHODS.includes(m.paymentMethod));
}

export function createMandatoryFieldsObject({ contact, dispatchType, address, paymentMethod }) {
  const { email, firstName, lastName, phone } = contact;
  const { countryCode, formatted, number, street, city, postalCode } = address || {};

  const result = {
    email,
  };

  if (paymentMethod !== 'offline') {
    result.firstName = firstName;
    result.lastName = lastName;
    result.phone = phone;

    if (dispatchType === 'delivery') {
      result.countryCode = countryCode;
      result.address = formatted;
      result.houseNumber = number;
      result.street = street;
      result.city = city;
      result.zipCode = postalCode;
    }
  }

  return _.omitBy(result, value => _.isUndefined(value) || _.isNull(value));
}

export function isOfflinePayment(payment = {}) {
  return payment.type === 'cashier' && payment.paymentMethod === 'offline';
}

function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export async function safeValidate(cashierApi) {
  let result = await cashierApi.validate();
  let retryCount = 0;

  while (!result.isValid && _.isEmpty(result.invalidFields) && retryCount < 9) {
    await delay(500);
    retryCount = retryCount + 1;
    result = await cashierApi.validate();
  }

  return result;
}
